import React, { useCallback, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { clearFacility } from '@resources/Facility/actions';
import { formErrorHandler } from '@common/utils/form';

const FormItem = Form.Item;

const FacilityForm = ({
	data,
	onSubmit,
	organization,
	clearFacility,
	onCancel,
}) => {
	const intl = useIntl();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleFinish = useCallback(
		(values) => {
			setLoading(true);
			if (organization?._id) {
				values['organization'] = organization?._id;
			}
			onSubmit(values)
				.then(() => {
					setLoading(false);
					form.resetFields();
				})
				.catch((err) => {
					setLoading(false);
					formErrorHandler(err, values, form);
				});
		},
		[onSubmit, organization]
	);

	return (
		<Form
			name="position-form"
			layout="vertical"
			onFinish={handleFinish}
			initialValues={data}>
			<FormItem
				label={intl.formatMessage({
					id: 'common.firstName',
					defaultMessage: 'First name',
				})}
				name="firstName"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.firstName.required',
							defaultMessage: 'Please enter first name',
						}),
					},
				]}>
				<Input
					placeholder={intl.formatMessage({
						id: 'common.firstName',
						defaultMessage: 'First name',
					})}
				/>
			</FormItem>
			<FormItem
				label={intl.formatMessage({
					id: 'common.lastName',
					defaultMessage: 'Last name',
				})}
				name="lastName"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.lastName.required',
							defaultMessage: 'Please enter last name',
						}),
					},
				]}>
				<Input
					placeholder={intl.formatMessage({
						id: 'common.lastName',
						defaultMessage: 'Last name',
					})}
				/>
			</FormItem>
			<FormItem
				label={intl.formatMessage({
					id: 'common.email',
					defaultMessage: 'Email',
				})}
				name="email"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.email.required',
							defaultMessage: 'Please enter email address',
						}),
					},
				]}>
				<Input
					placeholder={intl.formatMessage({
						id: 'common.email',
						defaultMessage: 'Email',
					})}
				/>
			</FormItem>
			<FormItem className="mt-5">
				<Button type="secondary" onClick={() => onCancel && onCancel()}>
					{intl.formatMessage({
						id: 'common.cancel',
						defaultMessage: 'Cancel',
					})}
				</Button>
				&nbsp;&nbsp;
				<Button
					loading={loading}
					type="primary"
					htmlType="submit"
					className="login-form-button">
					{intl.formatMessage({
						id: 'common.submit',
						defaultMessage: 'Submit',
					})}
				</Button>
			</FormItem>
		</Form>
	);
};

const mapStateToProps = ({ auth, organization }) => {
	return {
		auth,
		organization,
	};
};

export default connect(mapStateToProps, { clearFacility })(FacilityForm);
